import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import SnapshotGrid, { Snapshot } from './SnapshotGrid';
import SnapshotFilters, { SnapshotFiltersState } from './SnapshotFilters';
import AppPanel from '../fw/AppPanel.react';
import './FlowTestsView.scss';

interface Props {
    filters: SnapshotFiltersState;
    onFilterChange: (filters: SnapshotFiltersState) => void;
    snapshots: Snapshot[];
    breadcrumbParams: any[];
    title: string;
}

export default class FlowDefTestsView extends React.Component<Props> {
    render() {
        const { filters, onFilterChange, snapshots, breadcrumbParams, title } = this.props;

        return (
            <AppPanel
                breadcrumbParams={breadcrumbParams}
                title={title}
            >
                <Grid className="flow-tests-view" fluid>
                    <Row className="flow-tests-view__filters-row">
                        <Col md={12}>
                            <SnapshotFilters
                                filters={filters}
                                onFilterChange={onFilterChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <SnapshotGrid snapshots={snapshots} />
                        </Col>
                    </Row>
                </Grid>
            </AppPanel>
        );
    }
}
